var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('RouterView',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidePage),expression:"!hidePage"}],class:{ grayscale: _vm.grayscalePage }}),_vm._l((_vm.opened),function({ component, key, props }){return _c(component,_vm._b({key:key,tag:"Component"},'Component',props,false))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }